import { useAuth } from '@/hooks/useAuth';
import { FlightUpdateForm } from '@/components/organization/FlightUpdateForm';
import { useNavigate } from 'react-router-dom';
import { CreateFlightDialog } from '@/components/admin/CreateFlightDialog';
import { useState } from 'react';

export default function UpdateFlights() {
  const { session, profile } = useAuth();
  const navigate = useNavigate();
  const [refreshKey, setRefreshKey] = useState(0);

  const isAdmin = profile?.role === 'admin' || profile?.role === 'administrator';

  // Redirect if not authenticated or if user is public role
  if (!session || !profile) {
    navigate('/login');
    return null;
  }

  if (profile.role === 'public') {
    navigate('/');
    return null;
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Main Content */}
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          {isAdmin && (
            <div className="mb-6 flex justify-end">
              <CreateFlightDialog 
                onFlightCreated={() => setRefreshKey(prev => prev + 1)}
              />
            </div>
          )}
          <FlightUpdateForm key={refreshKey} />
        </div>
      </div>
    </div>
  );
}
